// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3NW_Z","buttons":"Footer_buttons__ANuMS"};